export default __webpack_public_path__ + "static/media/juniper.731ae0ac.png";